// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7704af96","977":"ee531c17"}[chunkId] + ".chunk.js";
};